// Code for the main App component that defines the routes for the application.
import React, { useEffect, Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import axiosInstance from './axios';

// 페이지별 컴포넌트를 import
const HomePage = lazy(() => import('./pages/HomePage'));
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const EndovascularAAARepairPage = lazy(() => import('./pages/EndovascularAAARepairPage'));
const OpenAAARepairPage = lazy(() => import('./pages/OpenAAARepairPage'));
const TEVARandComplexEvarPage = lazy(() => import('./pages/TevarAndComplexEvarPage'));
const AneurysmOthersPage = lazy(() => import('./pages/AneurysmOthersPage'));
const CarotidArteryStentingPage = lazy(() => import('./pages/CarotidArteryStentingPage'));
const CarotidEndarterectomyPage = lazy(() => import ('./pages/CarotidEndarterectomyPage'));
const InfrainguinalBypassPage = lazy(() => import('./pages/InfrainguinalBypassPage'));
const SupraInguinalBypassPage = lazy(() => import('./pages/SupraInguinalBypassPage'));
const LowerExtremityAmputationPage = lazy(() => import('./pages/LowerExtremityAmputationPage'));
const PeripheralVascularInterventionPage = lazy(() => import('./pages/PeripheralVascularInterventionPage'));
const HemodialysisAccessPage = lazy(() => import('./pages/HemodialysisAccessPage'));
const InferiorVenaCavaFilterInsertionPage = lazy(() => import('./pages/InferiorVenaCavaFilterInsertionPage'));
const OtherVenousStentInsertionPage = lazy(() => import('./pages/OtherVenousStentInsertionPage'));
const VaricoseVeinPage = lazy(() => import('./pages/VaricoseVeinPage'));
const VascularAccessPage = lazy(() => import('./pages/VascularAccessPage'));
const DiagnosticAngiographyPage = lazy(() => import('./pages/DiagnosticAngiographyPage'));
const PatientsListPage = lazy(() => import('./pages/PatientsListPage'));
const VisualizationPage = lazy(() => import('./pages/VisualizationPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const SignupPage = lazy(() => import('./pages/SignupPage'));
const SuccessPage = lazy(() => import('./pages/SuccessPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const Layout = lazy(() => import('./components/Layout'));
const AddPatientPortalPage = lazy(() => import('./pages/AddPatientPortal'));
const AIInsightsPage        = lazy(() => import('./pages/AIInsightsPage'));
const ResearchProjectPage   = lazy(() => import('./pages/ResearchProjectPage'));
const CustomMessagesPage    = lazy(() => import('./pages/CustomMessagesPage'));
const DataImportPage        = lazy(() => import('./pages/DataImportPage'));
const ImportConflictPage    = lazy(() => import('./pages/ImportConflictPage'));
const AnalysisDashboardPage = lazy(() => import('./pages/AnalysisDashboardPage'));

function App() {
  useEffect(() => {
    // 앱이 처음 로드될 때, CSRF 쿠키 발급 엔드포인트를 호출
    axiosInstance
      .get('/api/csrf/')
      .then(() => console.log('CSRF cookie set!'))
      .catch((err) => console.error('Failed to get CSRF cookie:', err));
  }, []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/add-patient-portal" element={<AddPatientPortalPage />} />

          {/* 시술 입력 페이지 */}
          <Route path="/endovascular-aaa-repair" element={<EndovascularAAARepairPage />} />
          <Route path="/open-aaa-repair" element={<OpenAAARepairPage />} />
          <Route path="/tevar-complex-evar" element={<TEVARandComplexEvarPage />} />
          <Route path="/aneurysm-others" element={<AneurysmOthersPage />} />

          <Route path="/carotid-endarterectomy" element={<CarotidEndarterectomyPage />} />
          <Route path="/carotid-artery-stenting" element={<CarotidArteryStentingPage />} />

          <Route path="/infra-inguinal-bypass" element={<InfrainguinalBypassPage />} />
          <Route path="/supra-inguinal-bypass" element={<SupraInguinalBypassPage />} />

          <Route path="/lower-extremity-amputation" element={<LowerExtremityAmputationPage />} />

          <Route path="/peripheral-vascular-intervention" element={<PeripheralVascularInterventionPage />} />
          <Route path="/hemodialysis-access" element={<HemodialysisAccessPage />} />
          <Route path="/inferior-vena-cava-filter-insertion" element={<InferiorVenaCavaFilterInsertionPage />} />

          <Route path="/other-venous-stent-insertion" element={<OtherVenousStentInsertionPage />} />
          <Route path="/varicose-vein" element={<VaricoseVeinPage />} />
          <Route path="/vascular-access" element={<VascularAccessPage />} />

          <Route path="/diagnostic-angiography" element={<DiagnosticAngiographyPage />} />

          {/* 환자 목록 / 결과 확인 페이지 */}
          <Route path="/patients-list" element={<PatientsListPage />} />

          {/* 시각화 페이지 */}
          <Route path="/visualization" element={<VisualizationPage />} />

          {/* AI Insights (RAG) */}
          <Route path="/ai-insights" element={<AIInsightsPage />} />

          {/* 공동 연구 */}
          <Route path="/research-project"  element={<ResearchProjectPage />} />
          <Route path="/custom-messages"   element={<CustomMessagesPage />} />

          {/* 분석 대시보드 */}
          <Route path="/analysis" element={<AnalysisDashboardPage />} />

          {/* 데이터 가져오기 */}
          <Route path="/data-import" element={<DataImportPage />} />
          <Route path="/import-conflicts" element={<ImportConflictPage />} />

          {/* 인증 관련 */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />

          {/* 입력 성공/완료 페이지 */}
          <Route path="/success" element={<SuccessPage />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </Suspense>
  );
}

export default App;
